import React from 'react';
import { ExternalLink } from 'lucide-react';

const KIGSection = () => {
  return (
    <section id="kig" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Titel */}
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-8 text-left">
            Das Klima- und Innovationsgesetz
          </h2>

          {/* Text Content */}
          <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6 text-left">
            <p>
              Das Bundesgesetz über die Ziele im Klimaschutz, die Innovation und die Stärkung der Energiesicherheit legt den langfristigen klimapolitischen Rahmen der Schweiz fest. Es verfolgt das Ziel, die Treibhausgasemissionen schrittweise zu senken, die Widerstandsfähigkeit gegenüber den Folgen des Klimawandels zu stärken und Innovationen sowie die Energiesicherheit zu fördern. Grundlage bildet das Übereinkommen von Paris.
            </p>

            <p>
              Kern des Gesetzes ist das verbindliche Netto Null Ziel. Die Schweiz soll spätestens bis 2050 keine klimaschädliche Wirkung mehr aus von Menschen verursachten Treibhausgasemissionen aufweisen. Dieses Ziel soll primär durch Emissionsreduktionen im Inland erreicht werden. Unvermeidbare Restemissionen werden durch den Einsatz von Negativemissionstechnologien ausgeglichen. Nach 2050 soll die Menge des dauerhaft entfernten und gespeicherten CO2 die verbleibenden Emissionen übersteigen.
            </p>

            <p>
              Das Gesetz definiert verbindliche Zwischenziele zur Emissionsminderung gegenüber dem Stand von 1990. Für die Zeiträume bis 2040 und bis 2050 sind deutliche Reduktionen vorgesehen. Ergänzend werden sektorielle Richtwerte für Gebäude, Verkehr und Industrie festgelegt. Diese sollen sicherstellen, dass alle zentralen Wirtschaftsbereiche ihren Beitrag zur Zielerreichung leisten.
            </p>

            <p>
              Unternehmen sind verpflichtet, spätestens ab 2050 Netto Null Emissionen aufzuweisen. Zur Unterstützung können sie freiwillige Fahrpläne zur Emissionsreduktion erarbeiten. Der Bund stellt hierfür Grundlagen, Standards und fachliche Beratung zur Verfügung. Bis 2030 werden zudem finanzielle Fördermittel für neuartige Technologien und Prozesse bereitgestellt, die zur Umsetzung dieser Fahrpläne beitragen. Zusätzlich können Investitionsrisiken bei klimarelevanten öffentlichen Infrastrukturen abgesichert werden.
            </p>

            <p>
              Ein weiterer Schwerpunkt des Gesetzes liegt auf der Anpassung an den Klimawandel. Bund und Kantone sind verpflichtet, Massnahmen zum Schutz von Bevölkerung, Sachwerten und natürlichen Lebensräumen umzusetzen. Ziel ist insbesondere die Begrenzung von Schäden durch steigende Temperaturen, veränderte Niederschlagsmuster und zunehmende Extremereignisse.
            </p>

            <p>
              Das Gesetz verpflichtet den Bund ausserdem, den Schweizer Finanzplatz auf eine klimaverträgliche Ausrichtung der Finanzmittelflüsse hinzuwirken. Finanzielle Aktivitäten sollen künftig stärker mit den Zielen einer emissionsarmen und klimaresilienten Entwicklung im Einklang stehen.
            </p>

            <p>
              Bund und Kantone übernehmen eine Vorbildfunktion. Die zentrale Bundesverwaltung muss spätestens bis 2040 Netto Null Emissionen erreichen. Dabei werden auch indirekte sowie vor und nachgelagerte Emissionen berücksichtigt. Die Kantone und bundesnahen Betriebe streben dasselbe Ziel an.
            </p>

            <p>
              Die konkrete Umsetzung der Ziele erfolgt über das CO2 Gesetz in mehreren Etappen bis 2050. Dabei werden wirtschaftliche Tragbarkeit, technologische Machbarkeit und soziale Verträglichkeit ausdrücklich berücksichtigt.
            </p>

            <p className="font-semibold text-gray-900">
              Das Klimaschutzgesetz ist seit dem 1. Januar 2025 in Kraft und bildet die strategische Grundlage für die langfristige Klima und Energiepolitik der Schweiz.
            </p>
          </div>

          {/* Button */}
          <div className="mt-12">
            <a
              href="https://www.fedlex.admin.ch/eli/cc/2023/655/de"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors shadow-lg hover:shadow-xl"
            >
              Publikationsplattform
              <ExternalLink size={20} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KIGSection;
